export default __webpack_public_path__ + "static/media/new-hero-2.2c5eab92.svg";